import { useAtom } from "jotai";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { workspaceIdAtom } from "../../../atoms/WorkspaceAtoms";
import { pageSettingsAtom } from "../../../atoms/PageAtoms";
import PageAPI from "../../api/PageAPI";
import { updatePageInPages } from "../../../utils/PageUtils";
import {
  callFunctionIfExists,
  getErrorMessage,
} from "../../../utils/GeneralUtils";

const useUpdatePageSettings = () => {
  const [workspaceID] = useAtom(workspaceIdAtom);
  const queryClient = useQueryClient();
  const [selectedPage, setSelectedPage] = useAtom(pageSettingsAtom);

  const updatePageSettings = useMutation({
    mutationFn: ({
      pageID,
      payload,
      onSuccess,
    }: {
      pageID: string;
      payload: any;
      onSuccess?: () => void;
    }) => {
      return PageAPI.updatePageSettings(workspaceID, pageID, payload).then(
        (data) => {
          const newPage = data.data.data.page;
          const newWorkspace = data.data.data.workspace;

          queryClient.setQueryData(["page", pageID], newPage);
          updatePageInPages(queryClient, newPage, workspaceID);
          queryClient.setQueryData(["workspace", workspaceID], (data) => ({
            ...(data || {}),
            workspace: newWorkspace,
          }));
          if (selectedPage?.id === newPage.id) {
            setSelectedPage(newPage);
          }

          callFunctionIfExists(onSuccess);
        }
      );
    },
  });

  return {
    updatePageSettings: updatePageSettings.mutate,
    updateSubmitting: updatePageSettings.isPending,
    updateError: updatePageSettings.error
      ? getErrorMessage(updatePageSettings.error)
      : null,
  };
};

export default useUpdatePageSettings;
